import { useAtomValue } from 'jotai';

import { getConfig } from '../../../config';
import { IsGraphClawHubMockEnabledAtom } from './state/atoms';

export const useGraphClawHubMockMode = (): boolean => {
	const enabled = useAtomValue(IsGraphClawHubMockEnabledAtom);
	// Direct local links can select either data source before permissions expose the toggle.
	if (
		typeof window !== 'undefined' &&
		getConfig().isLocalDev &&
		window.location.pathname === '/graphclaw-hub/review'
	) {
		const preview = new URLSearchParams(window.location.search).get('reviewPacketMock');
		if (preview === 'true' || preview === 'false') return preview === 'true';
	}
	return enabled;
};
